import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {TokenInterceptorService} from './token-interceptor.service';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true}
];
